import { Pipe, PipeTransform } from '@angular/core';
import { TimeSlot } from '@checkout/const';

@Pipe({
  name: 'minimalPrice',
  standalone: false,
})
export class TimeSlotsMinimalPrice implements PipeTransform {
  transform(timeSlots: TimeSlot[]): number {
    const prices = timeSlots.map((timeSlot) => timeSlot.price);

    return Math.min.apply(null, prices);
  }
}
